<template>
  <div class="animated fadeIn">
    <Forms ref="frmObjetoAcao"
      :title="'CADASTRO DE OBJETO DE AÇÃO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Objeto de Ação:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome do Objeto de Ação'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ObjetoAcaoModel from '@/shared/models/configurations/objetoacaomodel.js'
import ObjetoAcaoForms from './objetoacao-form.js'
import ObjetoAcaoRepository from '@/shared/http/repositories/configurations/objetoacao.js'

export default {
  name: 'ObjetoAcaoAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ObjetoAcaoModel,
      form: ObjetoAcaoForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      ObjetoAcaoRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ObjetoAcaoRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/objetoacao/components/add/objetoacaoadd.vue